import './EditorSidebar.scss';

import { FC, useState } from 'react';
import { DocumentComment } from 'models/DocumentComment';
import { PromptFlow } from 'models/PromptFlow';
import { Col, Row, Tab, Tabs } from 'react-bootstrap';

import CommentsContainer from '../CommentsContainer/CommentsContainer';
import PromptFlows from '../PromptFlows/PromptFlows';


interface EditorSidebarProps {
  comments: DocumentComment[]
  onExecuteAction: (action: PromptFlow) => void;
  // eslint-disable-next-line react/no-unused-prop-types
  onAddComment: (comment: DocumentComment) => boolean;
}

const EditorSidebar: FC<EditorSidebarProps> = ({ comments, onExecuteAction }) => {
  const ACTIVITY = 'activity';
  const AI = 'AI';
  const [tabKey, setTabKey] = useState(AI);

  return (
    <Col md={3} sm={12} className="px-0 editor-sidebar">
      <Tabs
        defaultActiveKey={AI}
        activeKey={tabKey}
        onSelect={(k: any) => setTabKey(k)}
        transition={false}
        id="document-editor-tabs"
        className="mb-3 pt-2 doc-tabs"
      >
        <Tab key={1} eventKey={AI} className='ai-writing-tab' title={<span><i className="bi bi-magic" />{" "}AI Writing</span>}>
          <Row className="mt-1">
            <PromptFlows onExecuteAction={onExecuteAction} />
          </Row>
        </Tab>
        <Tab key={2} eventKey={ACTIVITY} className='activity-tab' title={<span><i className="bi bi-chat-dots" />{" "}Activity</span>}>
          <Row className="mt-1">
            <CommentsContainer rejectionComments={comments} />
          </Row>
        </Tab>
      </Tabs>
    </Col>
  );
}

export default EditorSidebar;
